import type { ReactNode } from 'react';
import { QueryClientProvider, type QueryClient } from '@tanstack/react-query';
import { ApiProvider } from './lib/ApiProvider';
import { AuthProvider } from './auth/AuthContext';
import type { ApiClient } from './lib/api';

/**
 * Shared provider stack (API client, TanStack Query, Auth). Both the production
 * entrypoint and component tests compose it, passing an injected ApiClient +
 * QueryClient — tests pass fakes so no backend or network is required.
 */
export function AppProviders({
  client,
  queryClient,
  children,
}: {
  client: ApiClient;
  queryClient: QueryClient;
  children: ReactNode;
}): JSX.Element {
  return (
    <ApiProvider client={client}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>{children}</AuthProvider>
      </QueryClientProvider>
    </ApiProvider>
  );
}
